export const NAVIGATION = {
  name: 'Fragebogen',
  icon: 'fa-id-card-o',
  path: '/module/questionnaire/',
  children: [{
    name: 'Thieme Vorlagen',
    path: '/module/thieme-catalog/grid',
    icon: 'fa-book'
  }]
};
